module.exports = "/images/home-hero.png?7e2759791ccffb03781a4a4419bf9275";